<template>
  <main>
    <Container
      padding="30px 0"
      :breakpoints="{
        xs: 0,
        sm: 480,
        md: 768,
        lg: 1024,
        xl: 1280,
        xxl: 1440,
      }"
    >
      <div class="profile-wrapper">
        <div class="profile-navbar-wrapper">
          <div class="profile-navbar-side" data-aos="fade-out">
            <nav class="profile-navbar">
              <ul class="profile-navbar-menu">
                <li
                  v-for="item in navItems"
                  :key="item.name"
                  class="profile-navbar-item"
                >
                  <router-link
                    :to="item.path"
                    class="profile-navbar-link"
                    active-class="profile-active-link"
                    :exact="item.path === '/profile'"
                  >
                    <TextField
                      tag="span"
                      size="18"
                      weight="500"
                      color="#262626"
                      hoverColor="#0056b3"
                      :enableHover="true"
                    >
                      {{ $t(`profile.${[item.name]}`) }}
                    </TextField>
                  </router-link>
                </li>
              </ul>
            </nav>
          </div>

          <router-view></router-view>
        </div>
      </div>
    </Container>
  </main>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Profile",
  data() {
    return {
      navItems: [
        { name: "profileTab", path: "/profile" },
        { name: "childrenTab", path: "/profile/children" },
        { name: "requestsTab", path: "/profile/applications" },
        // { name: "tabelsTab", path: "/profile/tabels" },
      ],
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
};
</script>

<style scoped>
.profile-navbar-wrapper {
  max-width: 1280px;
  margin: 0 auto;
}
.profile-navbar {
  padding: 30px 0;
}
.profile-navbar-menu {
  display: flex;
  list-style: none;
  gap: 60px;
  padding: 0;
  margin: 0;
}
.profile-navbar-item {
  position: relative;
}
.profile-navbar-link.profile-active-link {
  font-weight: bold;
  border-bottom: 2px solid #0056b3;
  margin-top: 5px;
}
.profile-navbar-link.profile-active-link span {
  color: #0056b3 !important;
}
.profile-navbar-link {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  position: relative;
  transition: color 0.3s ease;
}
.profile-navbar-link:hover {
  color: #0056b3;
}
.profile-navbar-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #0056b3;
  transition: width 0.3s ease;
}
.profile-navbar-link:hover::after {
  width: 100%;
}

@media (max-width: 640px) {
  .profile-navbar-menu {
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
  }
}
</style>
